<div>
  <mat-card class="terms-container">
    <!--! Title -->
    <div class="terms-title">
      <ddc-text-gradient
        class="dashboard-header-txt dashboard-title text-2xl"
        [_text]="'Terms and Conditions of Use'"
        [_type]="'1'"
      ></ddc-text-gradient>
    </div>
    <div class="agreement-container text-sm">
      <div style="color: gray" [innerHTML]="'Last Update: ' + _lastUpdate"></div>
      <div [innerHTML]="_text"></div>
    </div>
  </mat-card>
</div>
